import utils from "../utils";
import {DEFAULT_PAGE} from "../config";

const usePage = () => {
    const filters = utils.get_filters();
    return utils.get_value_by_cur_filters({filters, field: "page", default_value: DEFAULT_PAGE});
};

export default usePage;